module.exports = __webpack_public_path__ + "static/miro-users-2041f2cb5af25fb399b861cc49bc8481.svg";